import type { Client } from "../client";
import type { TelemetryConfigurationResource } from "../resources/telemetryConfigurationResource";
import { ConfigurationRepository } from "./configurationRepository";
export class TelemetryConfigurationRepository extends ConfigurationRepository<TelemetryConfigurationResource> {
    constructor(client: Client) {
        super("TelemetryConfiguration", client);
    }
}
